import React, { useContext, useEffect, useState } from "react";

const NetworkStatusContext = React.createContext(null);

export const NetworkStatusProvider = ({ children }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        const interval = setInterval(async () => {
            try {
                // Try to fetch a lightweight external resource to confirm connectivity
                // Using no-cors mode to avoid CORS errors. 
                // We just want to know if the request fails (network error) or completes (even if opaque).
                const res = await fetch("https://www.google.com/favicon.ico?_" + new Date().getTime(), {
                    method: 'HEAD',
                    mode: 'no-cors',
                    cache: 'no-store'
                });

                // If we get here, we have a connection (even if it's 404/403/opaque)
                if (!isOnline) setIsOnline(true);

            } catch (e) {
                // Network error (DNS, connection refused, etc.) means we are likely offline
                if (isOnline) setIsOnline(false);
            }
        }, 5000); // Check every 5 seconds for better responsiveness

        // Cleanup listeners when the component unmounts
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            clearInterval(interval);
        };
    }, [isOnline]);

    return (
        <NetworkStatusContext.Provider value={{ isOnline }}>
            {children}
        </NetworkStatusContext.Provider>
    );
};

// Custom hook for easy consumption
export const useNetworkStatus = () => {
    return useContext(NetworkStatusContext);
};
